"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _react = _interopRequireDefault(require("react"));
var _box = require("@oneloop/box");
var _theme = _interopRequireDefault(require("@oneloop/theme"));
var _excluded = ["variant", "active"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Card = exports.Card = function Card(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'normal' : _ref$variant,
    active = _ref.active,
    props = _objectWithoutProperties(_ref, _excluded);
  var variantValues = Object.values(_theme["default"].card)[Object.keys(_theme["default"].card).indexOf(variant)];
  var backgroundColor = active ? variantValues[':focus'].backgroundColor : variantValues.backgroundColorValue;
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    sx: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    tx: "card",
    variant: variant
  }, props, {
    __css: {
      fontFamily: 'primary',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: backgroundColor,
      position: 'relative',
      gap: '8px',
      cursor: 'pointer'
    }
  })));
};